import { PAGINATION_WIRE_NAMES } from '../paginationWireNames';
import type { ByCursorKeys, ByPageKeys } from '../types';
import { SDK_RESULT } from './sdkResult';

const PAGE = PAGINATION_WIRE_NAMES.page;
const CURSOR = PAGINATION_WIRE_NAMES.cursor;

// gloss
export const DEFAULT_KEYS: { page: ByPageKeys; cursor: ByCursorKeys } = {
  page: {
    page: PAGE.page,
    pageSize: PAGE.pageSize,
    data: `${SDK_RESULT.body}.${PAGE.data}`,
    total: `${SDK_RESULT.body}.${PAGE.pagination}.${PAGE.total}`,
    totalPages: `${SDK_RESULT.body}.${PAGE.pagination}.${PAGE.totalPages}`,
  },
  cursor: {
    cursor: CURSOR.cursor,
    pageSize: CURSOR.pageSize,
    data: `${SDK_RESULT.body}.${CURSOR.data}`,
    nextCursor: `${SDK_RESULT.body}.${CURSOR.pagination}.${CURSOR.nextCursor}`,
  },
};
